/*
this is required because React.lazy can only work with default exports
https://reactjs.org/docs/code-splitting.html#named-exports
* */
export type Props = {
  show: boolean;
  onClose: () => void;
  onExited?: () => void;
  onError: (error: any, arg1: Promise<any>) => void | null;
  onSave: (arg0: any) => void;
  saveOptions?: {
    format: 'jpeg' | 'png';
    quality: number;
    multiplier: number;
    enableRetinaScaling: boolean;
  };
  image: string;
  plugins?: Array<any>;
};
import {BasicImageEditor} from 'basic-image-editor';
export default BasicImageEditor;
